module.exports = __webpack_public_path__ + "img/portugal-liver-cancer-female.6554da9b.png";